import { Injectable } from '@angular/core';
import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  SupportedLanguage,
} from 'src/app/app.config';
import browserLang from 'browser-lang';

const APP_LANGUAGE_KEY = 'app_language';

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  getLanguage(): SupportedLanguage {
    const languageCodeFromStorage = localStorage.getItem(APP_LANGUAGE_KEY);
    if (
      !languageCodeFromStorage ||
      !SUPPORTED_LANGUAGES.some(lang => lang === languageCodeFromStorage)
    ) {
      this.setLanguage(
        browserLang({
          languages: [...SUPPORTED_LANGUAGES],
          fallback: DEFAULT_LANGUAGE,
        }) as SupportedLanguage,
      );
      return this.getLanguage();
    }
    return languageCodeFromStorage as SupportedLanguage;
  }

  setLanguage(language: SupportedLanguage): void {
    localStorage.setItem('app_language', language);
  }

  setLanguageAndReload(language: SupportedLanguage): void {
    this.setLanguage(language);
    window.location.reload();
  }
}
